// extracted by mini-css-extract-plugin
export var askAiIcon = "_n9-9";
export var container = "_n9-0";
export var groupSeparator = "_n9-a";
export var highlight = "_n9-4";
export var resultIcon = "_n9-5";
export var resultItem = "_n9-7";
export var resultSubtitle = "_n9-3";
export var resultTitle = "_n9-2";
export var resultsList = "_n9-1";
export var searchGroup = "_n9-6";
export var selected = "_n9-8";